import React, {useRef} from "react";
import api from "api";
import update from "immutability-helper";
import { popinfo } from "component/Fancybox/Fancybox";
import { connect } from "react-redux";
import { SetTokenizeUser } from "store/dispatcher";
import { AvatarGetPicture } from "component/Avatar";
import stateMap from "store/stateMap";
import { RefreshAzureToken } from "component/LoginBox/LoginBox";

const EditProfilePicture = connect(stateMap, {SetTokenizeUser})((props) => {
    const photoFileButton           = useRef(null);

    const PhotoChanged = (e) => {
        e.stopPropagation();
        e.preventDefault();
        var file = e.target.files[0];

        if(['image/png', 'image/jpg', 'image/jpeg'].indexOf(file.type) < 0)
        {
            return popinfo('error', 'File not supported', 'Please use choose file between jpg &amp; png');
        }

        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('loadend', (e) => {
            const fr = e.target;
            var result = fr.result;

            let SavingPhoto = popinfo('loading', 'Saving Photo', 'Please Wait');

            api('/UploadProfilePicture', 'post', {
                data : result
                ,type : file.type
                ,name :file.name
                ,size : file.size
            }, 'Bearer ' + props.auth.token )
                .then(response => {
                    
                    RefreshAzureToken(props.auth.user.Token3rd, props.auth.user.Token3rdExpires)
                        .then(() => {
                            SavingPhoto.close();
                        
                            props.SetTokenizeUser(
                                update(props.auth.user, {
                                    UserPhoto : {
                                        $set : response.photo
                                    }
                                })
                            );
                            
                        })


                })
                .catch(error => {
                    popinfo('loading', 'Saving Photo', error, {}, SavingPhoto);
                })
        })
    }

    return (
        <div className="change-profpic">
            <span className="image-box square circle" onClick={e => {
                e.preventDefault();
                photoFileButton.current.click();
            }}>
                <img src={AvatarGetPicture(props.auth.user)} alt="" />
            </span>
            <span className="text-xs mt-sm block">Change your profile picture</span>
            <input type="file" ref={photoFileButton} style={{visibility : 'hidden'}} onChange={PhotoChanged} />
        </div>
    )
});

export default EditProfilePicture;